import * as React from "react";
import Skeleton from "@mui/material/Skeleton";
import styles from "styles/pages/DrivingRange.module.scss";

export default function HeatMapListSkeleton() {
	const listsToRender = 8;

	return (
		<div>
			<table className={styles.skeleton_table_bar}>
				<tbody>
					{Array(listsToRender)
						.fill(1)
						.map(() => (
							<tr>
								<td className={styles.country_cont}>
									<Skeleton height={40} />
									<div className={styles.city_box}>
										<td>
											{" "}
											<Skeleton height={40} />
										</td>
									</div>
								</td>
								<td className={styles.city_cont}>
									{" "}
									<Skeleton height={40} />
								</td>
								<td className={styles.state_cont}>
									{" "}
									<Skeleton height={40} />
								</td>
								<td className={styles.country_cont}>
									{" "}
									<Skeleton height={40} />
								</td>
								<td className={styles.country_cont}>
									{" "}
									<Skeleton height={40} />
								</td>
								<td className={styles.action_cont}>
									{" "}
									<Skeleton height={40} />
								</td>
								<td className={styles.action_cont}>
									{" "}
									<Skeleton height={40} />
								</td>
								<td className={styles.action_cont}>
									{" "}
									<Skeleton height={40} />
								</td>
							</tr>
						))}
				</tbody>
			</table>
		</div>
	);
}
